import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      background: '#1e1b4b',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '28px 24px',
      marginTop: 'auto',
    }}>
      <div style={{
        maxWidth: 1100,
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16,
      }}>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#4b5563' }}>
            privacy<span style={{ color: '#4b5563' }}>.</span>education
          </span>
          <Link to="/privacy" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>
            Privacy Notice
          </Link>
        </div>
        <div style={{ fontSize: 12, color: '#4b5563' }}>
          No advertising trackers &middot; Data stored in Canada (AWS ca-central-1)
        </div>
      </div>
    </footer>
  );
}
